/* tslint:disable:no-unused-expression */
import { Grid, Theme, Typography, WithStyles, withStyles } from '@material-ui/core';
import withTheme from '@material-ui/core/styles/withTheme';
import { IJackpotGameResultData, IJackpotGameResultDataType } from '@pbl/pbl-react-core/lib/models/games/types';
import { assets } from '@pbl/pbl-react-web-components/lib/config/assets';
import { CardContentLoader } from '@pbl/pbl-react-web-components/lib/package';
import styles from './HotColdScreenStyle';
import classNames from 'classnames';
import constants from 'config/constants';
import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'redux/reducers';
import { getLatestJackpotResult, resetJackpotError } from 'redux/reducers/games/actions';

export interface IScreenProps extends StateProps, DispatchProps, WithStyles<typeof styles> {
  theme: Theme;
  latestDraw?: string;
}

const convertResultDataForKeno = (resultData: IJackpotGameResultData[], resultType: IJackpotGameResultDataType) => {
  const sorted = _.orderBy(resultData, ['order']).filter(
    // @ts-ignore
    item => item.type === IJackpotGameResultDataType[resultType]
  );
  return _.map(sorted, 'data').map(item => parseInt(item, 10));
};

class HotColdScreen extends React.Component<IScreenProps> {

  public async componentDidMount() {
    if (this.props.latestDraw === 'latest') {
      await this.props.getLatestJackpotResult(constants.KENO_ID);
    }
  }

  public render() {
    const { classes, hotNumbers, coldNumbers, loading, errorMessage } = this.props;

    if (loading && !(hotNumbers.length > 0 && coldNumbers.length > 0)) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', margin: 16, maxWidth: 850 }}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={6} md={4}>
              <CardContentLoader loaderStyle={'loyalty'} />
            </Grid>
          </Grid>
        </div>
      );
    }

    if (!loading && !!errorMessage && !!errorMessage.additionalInformation && !!errorMessage.additionalInformation.hotAndCold) {
      return (
        <div className={classes.root}>
          <div className={classes.errorTextContainer}>
            {errorMessage.additionalInformation.hotAndCold.map(errorMsg => (
              <Typography variant="h6" className={classes.errorText}>
                {errorMsg}
              </Typography>
            ))}
          </div>
        </div>
      );
    }

    if (hotNumbers.length > 0 || coldNumbers.length > 0) {
      return (
        <div className={classes.root}>
          <Typography variant="h3" className={classes.title}>
            Hot Numbers
          </Typography>
          <div className={classes.numbersRow}>
            {hotNumbers.map((hotNumber: number) => (
              <div className={classes.numberContainer} key={hotNumber}>
                <img alt={'hot number'} src={assets.internalAssets.kenoHotNumberImg} className={classes.numberImage} />
                <Typography variant="h3" className={classNames(classes.numberText, classes.lightText)} style={{
                    color: '#000000',
                    background: 'radial-gradient(circle at 35% 15%, #f15a22 5%, #ffd200 60%, #f15a22 100%)',
                    boxShadow: 'inset 0 0 5px 2px #f15a22, 0 0 5px 0 #f15a22'
                }}>
                  {hotNumber}
                </Typography>
              </div>
            ))}
          </div>
          <Typography variant="h3" className={classes.title}>
            Cold Numbers
          </Typography>
          <div className={classes.numbersRow}>
            {coldNumbers.map((coldNumber: number) => (
              <div className={classes.numberContainer} key={coldNumber}>
                <img alt={'cold number'} src={assets.internalAssets.kenoColdNumberImg} className={classes.numberImage} />
                <Typography variant="h3" className={classNames(classes.numberText, classes.darkText)} style={{
                    color: '#000000',
                    background: 'radial-gradient(circle at 35% 15%, #66ccff 5%, #fefeff 60%, #66ccff 100%)',
                    boxShadow: 'inset 0 0 5px 2px #ffffff, 0 0 5px 0 #00a8e1'
                }}>
                  {coldNumber}
                </Typography>
              </div>
            ))}
          </div>
          <Typography variant="caption" className={classes.footer}>
            Based on the last 100 draws
          </Typography>
        </div>
      );
    }
    return (
      <div className={classes.root} />
    );
  }
}

const mapStateToProps = ({ games }: IRootState) => ({
  loading: games.loading,
  errorMessage: games.errorMessage,
  hotNumbers: !!games.resultData ? convertResultDataForKeno(games.resultData, IJackpotGameResultDataType.HOT) : [],
  coldNumbers: !!games.resultData ? convertResultDataForKeno(games.resultData, IJackpotGameResultDataType.COLD) : []
});

// @ts-ignore
const mapDispatchToProps = {
  getLatestJackpotResult,
  resetJackpotError
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(withStyles(styles)(HotColdScreen)));
